import { getApiClient } from '../../axios-config';
import Logger from '../../../../utils/logger';

/**
 * Disciplines API Service
 * Handles API calls for the global (not project-scoped) knowledge
 * discipline taxonomy used by the Project Documents Assistant.
 */
class DisciplinesAPI {
  /**
   * Get all active disciplines
   * @param {string} token - JWT authentication token
   * @returns {Promise<Array>} Array of discipline objects
   */
  static async getAll(token) {
    const apiClient = getApiClient(token);
    const response = await apiClient.get('/api/ai/project-docs/disciplines');
    Logger.debug('DisciplinesAPI.getAll - Response structure', {
      hasData: !!response.data?.data,
      disciplinesCount: response.data?.data?.disciplines?.length,
    });
    return response.data.data.disciplines || [];
  }
}

export default DisciplinesAPI;
